import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "dropdown select-dropdown" }
const _hoisted_5 = {
  class: "dropdown-toggle border text-body rounded-2 bg-transparent",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "default-table-area style-two recent-transactions py-19" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = { class: "text-body" }
const _hoisted_13 = { class: "text-body" }
const _hoisted_14 = { class: "text-body" }
const _hoisted_15 = { class: "d-flex align-items-center gap-1" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap p-4 pt-3" }
const _hoisted_20 = { class: "fs-13" }
const _hoisted_21 = { "aria-label": "Page navigation example" }
const _hoisted_22 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_23 = { class: "page-item" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "page-item" }
const _hoisted_27 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "mb-0" }, "Recent Transactions", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.selectedFilter), 1),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilters, (filter) => {
              return (_openBlock(), _createElementBlock("li", { key: filter }, [
                _createElementVNode("button", {
                  class: "dropdown-item text-secondary py-2 px-3",
                  onClick: ($event: any) => (_ctx.changeFilter(filter))
                }, _toDisplayString(filter), 9, _hoisted_7)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Date"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Description"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Category"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Amount ($)"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Status"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedTransactions, (transaction) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: transaction.id
                }, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.formatDate(transaction.date)), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(transaction.description), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(transaction.category), 1),
                  _createElementVNode("td", _hoisted_14, " $" + _toDisplayString(transaction.amount.toLocaleString()), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["d-inline-block rounded-pill fs-12 fw-medium border", _ctx.statusClasses(transaction.status)]),
                      style: {"padding":"1px 10px"}
                    }, _toDisplayString(transaction.status), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.viewTransaction(transaction))
                      }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ", -1)
                      ]))], 8, _hoisted_16),
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.editTransaction(transaction))
                      }, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ", -1)
                      ]))], 8, _hoisted_17),
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.deleteTransaction(transaction.id))
                      }, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ", -1)
                      ]))], 8, _hoisted_18)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, "Showing " + _toDisplayString(_ctx.showingRange) + " of " + _toDisplayString(_ctx.filteredTransactions.length) + " Results", 1),
          _createElementVNode("nav", _hoisted_21, [
            _createElementVNode("ul", _hoisted_22, [
              _createElementVNode("li", _hoisted_23, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_24)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_25)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_26, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_27)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}